import React from "react";
import { Link } from "react-router-dom";
import "./AdminLayout.css";


export default function AdminLayout() {
  return (
    <aside className="admin-category-menu">
      <Link to="/admin/users" className="category users">
        Users
      </Link>
      <Link to="/admin/products" className="category products">
        Products
      </Link>
      <Link to="/admin/orders" className="category orders">
        Orders
      </Link>
    </aside>
  );
}
